import { render, staticRenderFns } from "./sender-creation-steps.vue?vue&type=template&id=cbb6d230"
import script from "./sender-creation-steps.vue?vue&type=script&lang=js"
export * from "./sender-creation-steps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports